export enum HeapCustomEvent {
  BreakdownCreated = "Breakdown Created",
  TapeRequestSent = "Tape Request Sent",
  AgentRequestReceived = "Agent - Tape Request Received",
  CDToPerformerRequestReceived = "CD 2 Performer - Tape Request Received",
  AgentToPerformerRequestReceived = "Agent 2 Performer - Tape Request Received",
  AgentSendTapeRequestToPerformer = "Agent - Send Tape Request To Performer",
  AgentTapeRequestUpload = "Agent - Tape Request upload",
  PerformerTapeRequestUpload = "Performer - Tape Request upload",
  TapeRequestForbidden = "Tape Request Forbidden",
  // close breakdown early
  ClickClose = "CD - Step 1 : Click close breakdown early",
  ExitClose = "CD - Step 2: Exit close breakdown early",
  ReasonAndConfirm = "CD - Step 2: Reason and  confirm closing breakdown early",
  CosedEarly = "CD - Step 3: Breakdown is closed early",
  ExitConfirm = "CD - Step 3: Exit closing breakdown early",
  BackToStepTwo = "CD - Step 3: Back to step 2",
  // agent self tape request settings
  AgentSelfTapeEditSettings = "agent - editing self-tape settings",
  AgentSelfTapeToggleSetting = "agent - toggle self-tape setting",
  AgentSelfTapeSaveAndClose = "agent - save and close self-tape",
  AgentSelfTapeCancelSettings = "agent - cancel self-tape settings",
  // performer subscription plan
  PerformerCancelSubscription = "cancel_subscription",
  PerformerChangePlan = "Change Subscription Selected",
  PerformerAnotherPlan = "Change Subscription Type",
  PerformerChangePlanCancelled = "Change Subscription Cancelled",
  PerformerCancelSubscriptionModal = " Subscription Type",
  // social media events
  CdClickedSocialLink = "cd_clicked_social_link",
  // current profile usage events
  HeadShotPerformer = "performer_headshot_update", //scenario 1
  ProfileRedesignHeadShotPerformer = "profile_redesign_headshot_update",
  AudioClipsPerformer = "performer_audio_clips_update",
  ProfileRedesignAudioClipsPerformer = "profile_redesign_audio_clips_update",
  VideosPerformer = "performer_videos_update",
  ProfileRedesignVideosPerformer = "profile_redesign_videos_update",
  DetailsPerformer = "performer_details_update",
  ProfileRedesignDetailsPerformer = "profile_redesign_details_update",
  SkillsPerformer = "performer_skills_update",
  ProfileRedesignSkillsPerformer = "profile_redesign_skills_update",
  AboutMePerformer = "performer_about_me_update",
  ProfileRedesignHighlightsPerformer = "profile_redesign_highlights_update",
  CreditsPerformer = "performer_credits_update",
  ProfileRedesignCreditsPerformer = "profile_redesign_credits_update",
  HeadShotAgent = "agent_headshot_update",
  ProfileRedesignHeadShotAgent = "profile_redesign_agent_headshot_update",
  AudioClipsAgent = "agent_audio_clips_update",
  ProfileRedesignAudioClipsAgent = "profile_redesign_agent_audio_clips_update",
  VideosAgent = "agent_videos_update",
  ProfileRedesignVideosAgent = "profile_redesign_agent_videos_update",
  DetailsAgent = "agent_details_update",
  ProfileRedesignDetailsAgent = "profile_redesign_agent_details_update",
  SkillsAgent = "agent_skills_update",
  ProfileRedesignSkillsAgent = "profile_redesign_agent_skills_update",
  AboutMeAgent = "agent_about_me_update",
  ProfileRedesignHighlightsAgent = "profile_redesign_agent_highlights_update",
  CreditsAgent = "agent_credits_update",
  ProfileRedesignCreditsAgent = "profile_redesign_agent_credits_update",
  ProfileUpdate = "profile_update", // scenario 3
  ProfileRedesignUpdate = "profile_redesign_update", // scenario 3
  CDAudioVideoPlayed = "cd_audio_video_played", // scenario 4
  ProfileRedesignCDAudioVideoPlayed = "profile_redesign_cd_audio_video_played",
  AgentAudioVideoPlayed = "agent_audio_video_played",
  ProfileRedesignAgentAudioVideoPlayed = "profile_redesign_agent_audio_video_played",
  CDEmailProfile = "cd_email_profile", // scenario 5
  ProfileRedesignCDEmailProfile = "profile_redesign_cd_email_profile",
  AgentEmailProfile = "agent_email_profile",
  ProfileRedesignAgentEmailProfile = "profile_redesign_agent_email_profile",
  CDPrintProfile = "cd_print_profile", // scenario 6
  ProfileRedesignCDPrintProfile = "profile_redesign_cd_print_profile",
  AgentPrintProfile = "agent_print_profile",
  ProfileRedesignAgentPrintProfile = "profile_redesign_agent_print_profile",
  ProfileIsEdited = "profile_is_edited", // scenario 8
  ProfileRedesignIsEdited = "profile_redesign_is_edited",
}
